"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedV2Activities = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const ActivityFeedContext_1 = require("./ActivityFeedContext");
const DateSeparator_1 = require("./DateSeparator");
const FeedItem_1 = require("./FeedItem");
exports.testIds = {
    loader: 'activity_feed-loader',
    loadMoreBtn: 'activity_feed-load_more_button',
};
const trackingIds = {
    loadMoreButton: 'activity_feed_v2-load_more_feeds-trigger_button',
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    container: {
        width: '684px',
        borderRadius: 4,
        margin: '0 auto',
        padding: theme.spacing(2, 0, 4, 0),
    },
    activityFeedWrapper: {
        background: theme.palette.tag.info,
        margin: theme.spacing(0, 2),
        borderRadius: 8,
    },
    heading: {
        marginBottom: theme.spacing(3),
    },
    loadMoreButton: {
        margin: theme.spacing(3, 0),
    },
    emptyText: {
        padding: theme.spacing(2),
        textAlign: 'center',
    },
}));
const FeedV2Activities = () => {
    const classes = useStyles();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const { feedData, isInternal } = (0, ActivityFeedContext_1.useActivityFeedState)();
    const isForCustomer = !isInternal;
    const { state: { user }, } = (0, frontend_infra_auth_1.useAuth)();
    const feedListPages = feedData?.data?.pages || [];
    const renderDateSeparator = (currDate, prevDate) => {
        const currDateFormatted = new Date(currDate);
        currDateFormatted.setHours(0, 0, 0, 0);
        if (!prevDate) {
            return (0, jsx_runtime_1.jsx)(DateSeparator_1.DateSeparator, { date: currDateFormatted });
        }
        const prevDateFormatted = new Date(prevDate);
        prevDateFormatted.setHours(0, 0, 0, 0);
        return currDateFormatted < prevDateFormatted ? (0, jsx_runtime_1.jsx)(DateSeparator_1.DateSeparator, { date: currDateFormatted, hasPrevActivity: true }) : null;
    };
    const getPrevActivityDate = (feed, feedIndex, pageIndex) => {
        if (feedIndex > 0) {
            return feed[feedIndex - 1]?.activity.createdAt;
        }
        if (pageIndex > 0) {
            const prevFeed = feedListPages[pageIndex - 1]?.results || [];
            return prevFeed?.[prevFeed.length - 1]?.activity.createdAt;
        }
        return undefined;
    };
    if (feedData.isError) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { className: classes.activityFeedWrapper, children: (0, jsx_runtime_1.jsxs)("div", { className: classes.container, children: [feedListPages.map((page, pageIndex) => page.results.length > 0 ? (page.results.map((feedItem, feedIndex) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [feedItem.activity.createdAt &&
                            renderDateSeparator(feedItem.activity.createdAt, getPrevActivityDate(page.results, feedIndex, pageIndex)), (0, jsx_runtime_1.jsx)(FeedItem_1.FeedItem, { feed: feedItem, loggedInUserId: user?.['_id'], isForCustomer: isForCustomer ?? false }, feedItem.id)] }, feedItem.id)))) : ((0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { className: classes.emptyText, children: translate('activity-feed_empty-message') }, page.page))), feedData.isLoading && ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { display: "flex", justifyContent: "center", "data-testid": exports.testIds.loader, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.CircularProgress, {}) })), feedData.hasNextPage && ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { display: "flex", justifyContent: "center", pt: 1, "data-testid": exports.testIds.loadMoreBtn, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Button, { variant: "outlined", className: classes.loadMoreButton, onClick: () => feedData.fetchNextPage(), disabled: feedData.isFetchingNextPage, "data-tracking-id": trackingIds.loadMoreButton, children: feedData.isFetchingNextPage ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.CircularProgress, { size: 16 }), " ", translate('activity_feed-loading')] })) : (translate('activity-feed_load_more')) }) }))] }) }));
};
exports.FeedV2Activities = FeedV2Activities;
//# sourceMappingURL=FeedV2Activities.js.map